angular.module("app").controller("LoyaltyListController", [
    '$scope',
    'preloadedLevelsList',
    'loyaltyService',
    'errorHandler',
    'logger',
    '$timeout',
    '$state',
    'pagination',
    '$uibModal',
    'settingsService',
    '$cookies',
    'userStorage',
    function ($scope,
              preloadedLevelsList,
              loyaltyService,
              errorHandler,
              logger,
              $timeout,
              $state,
              pagination,
              $modal,
              settingsService,
              $cookies,
              userStorage) {

        var settings =  settingsService.getSettings(),
            pendingListRequest;


        preloadedLevelsList = preloadedLevelsList || {};
        $scope.labelColumnContainer= {
            column: "image",
            field: "label"
        };
        $scope.tooltip = {
            "display_name": ""
        };

        function convertPoints(points){
            return points.map(function (item){
                return {
                    id: item.id,
                    image: item.src,
                    display_name: item.display_name,
                    min_point: item.min_point,
                    max_point: item.max_point,
                    label:item.translated === "0"?"Not translated": "",
                    name: item.name,

                }
            })
        }

        $scope.points = convertPoints(preloadedLevelsList.points);
        $scope.filters = {
            lang: $cookies.get("preferedLanguage") || settings.skin.defaultLang
        }

        $scope.languages = settings.skin.languages;


        $scope.ignoreColumns = {
            'translated': true,
            'id': true,
            'label': true
        };


        $scope.updateList = function () {
            loyaltyService.getLevels($scope.filters.lang).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.points = convertPoints(response.points);
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.editLoyalty = function (level) {
            $modal.open({
                templateUrl: "views/products/loyalty/edit.html",
                controller: "EditLoyaltyController",
                resolve: {
                    preloadedPointData: function (errorHandler) {
                        return loyaltyService.getLevels($scope.filters.lang, level.id).then(
                            function (response) {
                                if (response.status === "ok") {
                                    return (response.points.length) ? response.points[0] : {}
                                }
                                errorHandler(response.message);
                                return {}
                            },
                            function (response) {
                                errorHandler(response.message)
                            }
                        )
                    },
                    preloadedImages: function (){
                        return loyaltyService.getImages().then(function (response) {
                                if (response.status === "ok") {
                                    return response.images;
                                }
                                errorHandler(response.message);
                                return {}
                            },
                            function (response) {
                                errorHandler(response.message)
                            })
                    },

                    lang: function (){
                        return $scope.filters.lang;
                    }


                }
            }).result.then(function () {
                $scope.updateList()
            });
        };
        if (userStorage.getUserData().permissions.indexOf('manageLoyaltyPoints') !== -1) {
            $scope.tools = {
                edit: {
                    action: function (item) {
                        $scope.editLoyalty(item);
                    }

                }
            };
        }

    }

]);
